// extracted by mini-css-extract-plugin
module.exports = {"inProgressStatus":"CollaboratorOnboardingRequirements_inProgressStatus__1skUE","completeStatus":"CollaboratorOnboardingRequirements_completeStatus__1P8cL"};